import "./src/styles/global.css"
import LanguageProvider from "./src/components/Language/LanguageProvider"
import GlobalPathTracker from "./src/components/Language/GlobalPathTracker"

export const wrapRootElement = LanguageProvider

export const wrapPageElement = GlobalPathTracker
